import { default as ProfileCardEdit } from "@/components/profile/basicDetails/edit";
import { default as EmailVerifyCard } from "@/components/profile/contactCard/components/Email";
import { default as MobileVerifyCard } from "@/components/profile/contactCard/components/Mobile";
import { default as EducationEditCard } from "@/components/profile/educationCard/edit";
import { default as PreferenceEditCard } from "@/components/profile/preferencesCard/edit";
import { ActionModalMapType } from "@/components/profile/profileScore/utils/types";
import { default as SummaryEditCard } from "@/components/profile/profileSummary/components/renderModal";
import { default as SkillsEditCard } from "@/components/profile/skills/edit";
import { default as SocialLinkEditCard } from "@/components/profile/socialLinkCard/edit";
import { default as WorkEditCard } from "@/components/profile/workExperience/edit";

export const actionModalMap: ActionModalMapType = {
  preference: {
    component: PreferenceEditCard,
    label: "Job Preferences",
  },
  "online-presence": {
    component: SocialLinkEditCard,
    label: "Online Presence",
  },
  education: {
    component: EducationEditCard,
    label: "Education",
  },
  work: {
    component: WorkEditCard,
    label: "Work Experience",
  },
  "profile-card": {
    component: ProfileCardEdit,
    label: "Basic details",
  },
  email: {
    component: EmailVerifyCard,
    label: "Verify email id",
  },
  mobile: {
    component: MobileVerifyCard,
    label: "Change phone Number",
  },
  skills: {
    component: SkillsEditCard,
    label: "Skills",
  },
  summary: {
    component: SummaryEditCard,
    label: "Summary",
  },
};
